import { DataProxy } from "./dataproxy";
import { extend } from "@dhx/ts-common/core";
import { ajax } from "./ajax";
import { ILazyConfig, ILazyDataProxy } from "./types";

export class LazyDataProxy extends DataProxy implements ILazyDataProxy {
	public config: ILazyConfig;

	private _timeout;
	private _cooling: boolean;

	constructor(url: string, config?: any) {
		super(url);
		this.config = extend(
			{
				from: 0,
				limit: 50,
				delay: 50,
				prepare: 0,
			},
			config
		);

		this.updateUrl(url, { from: this.config.from, limit: this.config.limit });
	}

	load<T = string>(): Promise<T> {
		return new Promise((resolve, reject) => {
			if (!this._timeout) {
				ajax.get(this.url, { responseType: "text" })
					.then(resolve)
					.catch(reject);
				this._cooling = true;
				this._timeout = setTimeout(() => {
					return;
				});
			} else {
				clearTimeout(this._timeout);

				this._timeout = setTimeout(() => {
					ajax.get(this.url, { responseType: "text" })
						.then(resolve)
						.catch(reject);
					this._cooling = true;
				}, this.config.delay);

				if (this._cooling) {
					resolve(null);
					this._cooling = false;
				}
			}
		});
	}
}
